import { z } from 'zod';
export const relationshipsInsuranceClaimsPartiesCapability = 'relationships.insurance-claim-parties.v1';
export const relationshipsInsuranceClaimsPartiesSlot = 'insurance-claims.relationship-parties';
export const relationshipsInsuranceClaimsPartiesProviderId = 'relationships.server.insurance-claims-parties';
const idSchema = z.string().uuid();
const sha256Schema = z.string().regex(/^[a-f0-9]{64}$/);
export const relationshipsInsuranceClaimsPartiesRequestSchema = z.strictObject({
    consumerModuleId: z.literal('insurance-claims'),
    requestedCapability: z.literal(relationshipsInsuranceClaimsPartiesCapability),
    resourceType: z.literal('insurance-claims.claim'),
    resourceId: idSchema,
    projectId: idSchema,
    carrierOrganizationId: idSchema.nullable(),
    adjusterContactId: idSchema.nullable(),
});
export const relationshipsInsuranceClaimsCarrierPartySchema = z.discriminatedUnion('state', [
    z.strictObject({ state: z.literal('not-linked') }),
    z.strictObject({
        state: z.literal('missing'),
        organizationId: idSchema,
    }),
    z.strictObject({
        state: z.literal('present'),
        organizationId: idSchema,
        displayName: z.string().trim().min(1).max(240),
        type: z.enum(['customer', 'insurance', 'vendor', 'adjuster', 'property_manager', 'other']),
        status: z.enum(['active', 'difficult', 'preferred', 'inactive']),
        updatedAt: z.string().datetime({ offset: true }),
    }),
]);
export const relationshipsInsuranceClaimsAdjusterPartySchema = z.discriminatedUnion('state', [
    z.strictObject({ state: z.literal('not-linked') }),
    z.strictObject({
        state: z.literal('missing'),
        contactId: idSchema,
    }),
    z.strictObject({
        state: z.literal('present'),
        contactId: idSchema,
        displayName: z.string().trim().min(1).max(241),
        type: z.enum(['customer', 'adjuster', 'agent', 'property_manager', 'vendor', 'internal', 'other']),
        status: z.enum(['active', 'difficult', 'vip', 'inactive']),
        organizationId: idSchema.nullable(),
        updatedAt: z.string().datetime({ offset: true }),
    }),
]);
export const relationshipsInsuranceClaimsPartiesResponseSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(relationshipsInsuranceClaimsPartiesCapability),
    projectId: idSchema,
    carrier: relationshipsInsuranceClaimsCarrierPartySchema,
    adjuster: relationshipsInsuranceClaimsAdjusterPartySchema,
    contentHash: sha256Schema,
    observedAt: z.string().datetime({ offset: true }).nullable(),
});
//# sourceMappingURL=relationships-insurance-claims-parties.contract.js.map